module.exports = __webpack_public_path__ + "static/media/ynap-analytics-implementation.79ceed0b.md";